import axios from "../utils/axios";

export const getQRCode = () =>
  axios.get("/api/qr");